
        import { isLoggedIn, login, getUser, authHeaders } from '/src/auth.ts';

        // ── Check Store Status ──
        (async () => {
            try {
                const res = await fetch('/api/store-status');
                const status = await res.json();

                if (status.announcement) {
                    const banner = document.createElement('div');
                    banner.style.cssText = 'background: rgba(243, 156, 18, 0.15); border: 1px solid rgba(243, 156, 18, 0.3); color: #f39c12; padding: 0.75rem 1.25rem; border-radius: 10px; margin-bottom: 1.5rem; font-size: 0.9rem; font-weight: 600; text-align: center;';
                    banner.textContent = status.announcement;
                    document.querySelector('.offerings-page .container')?.prepend(banner);
                }

                if (!status.mealkits) {
                    const mealkitsTab = document.getElementById('mealkits');
                    if (mealkitsTab) {
                        const overlay = document.createElement('div');
                        overlay.style.cssText = 'background: rgba(26, 23, 20, 0.85); border: 1px solid var(--border-color); border-radius: 15px; padding: 2rem; text-align: center; margin-bottom: 1.5rem;';
                        overlay.innerHTML = '<p style="color: #dc3545; font-weight: 700; font-size: 1.1rem; margin-bottom: 0.5rem;">Mealkit Orders Closed</p><p style="color: var(--text-medium); font-size: 0.9rem;">We\'re not accepting mealkit orders right now. Please check back later.</p>';
                        mealkitsTab.prepend(overlay);
                        mealkitsTab.querySelectorAll('button[data-plan]').forEach(b => { b.disabled = true; b.style.opacity = '0.4'; b.style.cursor = 'not-allowed'; });
                    }
                }

                if (!status.giftcards) {
                    const giftcardsTab = document.getElementById('giftcards');
                    if (giftcardsTab) {
                        const overlay = document.createElement('div');
                        overlay.style.cssText = 'background: rgba(26, 23, 20, 0.85); border: 1px solid var(--border-color); border-radius: 15px; padding: 2rem; text-align: center; margin-bottom: 1.5rem;';
                        overlay.innerHTML = '<p style="color: #dc3545; font-weight: 700; font-size: 1.1rem; margin-bottom: 0.5rem;">Gift Card Orders Closed</p><p style="color: var(--text-medium); font-size: 0.9rem;">We\'re not accepting gift card orders right now. Please check back later.</p>';
                        giftcardsTab.prepend(overlay);
                    }
                }

                if (!status.foodDelivery) {
                    const deliveryTab = document.getElementById('delivery');
                    if (deliveryTab) {
                        const overlay = document.createElement('div');
                        overlay.style.cssText = 'background: rgba(26, 23, 20, 0.85); border: 1px solid var(--border-color); border-radius: 15px; padding: 2rem; text-align: center; margin-bottom: 1.5rem;';
                        overlay.innerHTML = '<p style="color: #dc3545; font-weight: 700; font-size: 1.1rem; margin-bottom: 0.5rem;">Food Delivery Orders Closed</p><p style="color: var(--text-medium); font-size: 0.9rem;">We\'re not accepting food delivery orders right now. Please check back later.</p>';
                        deliveryTab.prepend(overlay);
                        deliveryTab.querySelectorAll('a.btn-primary').forEach(b => { b.style.opacity = '0.4'; b.style.pointerEvents = 'none'; });
                    }
                }
            } catch (err) {
                console.error('Failed to check store status:', err);
            }
        })();

        // ── Mealkit Plan — redirect to menu to pick meals ──
        document.querySelectorAll('#mealkits button[data-plan]').forEach(btn => {
            btn.addEventListener('click', (e) => {
                e.preventDefault();
                if (!isLoggedIn()) { login(); return; }
                const plan = btn.dataset.plan;
                window.location.href = '/hellofresh-menu?plan=' + encodeURIComponent(plan);
            });
        });

        // ── Gift Card Catalog ──
        let allGiftCards = [];
        let activeCat = '';
        let selectedDenom = null;
        let currentProductId = null;

        const searchInput = document.getElementById('gcSearchInput');
        const pillsWrap = document.getElementById('gcCategoryPills');
        const countEl = document.getElementById('gcCount');
        const catalogGrid = document.getElementById('gcCatalogGrid');
        const catalogLoading = document.getElementById('gcCatalogLoading');
        const catalogError = document.getElementById('gcCatalogError');

        // Category pill order
        const CAT_ORDER = ['Dining', 'Fast Food & Casual', 'Coffee & Treats', 'Entertainment', 'Shopping & Fashion', 'Home & Grocery', 'Wellness & Beauty', 'Featured', 'Other'];

        async function loadCatalog() {
            console.log('[GiftCards] Loading catalog...');
            try {
                const res = await fetch('/api/giftcards');
                console.log('[GiftCards] Response status:', res.status);
                
                if (!res.ok) {
                    const errorText = await res.text();
                    console.error('[GiftCards] API error:', errorText);
                    throw new Error(`API returned ${res.status}: ${errorText}`);
                }
                
                const data = await res.json();
                console.log('[GiftCards] Loaded data:', data);

                allGiftCards = data.items || [];
                console.log('[GiftCards] Total items:', allGiftCards.length);

                // Build pills
                pillsWrap.innerHTML = '';
                const allPill = document.createElement('button');
                allPill.className = 'gc-pill active';
                allPill.textContent = 'All';
                allPill.onclick = () => { activeCat = ''; updatePills(); renderCards(); };
                pillsWrap.appendChild(allPill);

                CAT_ORDER.forEach(cat => {
                    if (!data.categories[cat]) return;
                    const pill = document.createElement('button');
                    pill.className = 'gc-pill';
                    pill.textContent = cat;
                    pill.dataset.cat = cat;
                    pill.onclick = () => { activeCat = cat; updatePills(); renderCards(); };
                    pillsWrap.appendChild(pill);
                });

                catalogLoading.style.display = 'none';
                catalogGrid.style.display = 'grid';
                renderCards();
                console.log('[GiftCards] Catalog loaded successfully');
            } catch (err) {
                console.error('[GiftCards] Failed to load gift cards:', err);
                catalogLoading.style.display = 'none';
                catalogError.style.display = 'block';
                catalogError.innerHTML = `
                    <p style="color:#dc3545;font-weight:600;">Failed to load gift cards</p>
                    <p style="font-size:0.85rem;">${err.message}</p>
                    <button onclick="location.reload()" style="margin-top:1rem;padding:0.5rem 1rem;background:var(--accent-gold);color:white;border:none;border-radius:8px;cursor:pointer;">Retry</button>
                `;
            }
        }

        function updatePills() {
            pillsWrap.querySelectorAll('.gc-pill').forEach(p => {
                p.classList.toggle('active', activeCat ? p.dataset.cat === activeCat : !p.dataset.cat);
            });
        }

        function renderCards() {
            const q = searchInput.value.toLowerCase().trim();

            let filtered = [...allGiftCards];
            if (q) filtered = filtered.filter(c => c.name.toLowerCase().includes(q));
            if (activeCat) filtered = filtered.filter(c => c.category === activeCat);

            // Sort
            const sortVal = sortSelect ? sortSelect.value : 'name';
            if (sortVal === 'discount-desc') {
                filtered.sort((a, b) => b.discount - a.discount);
            } else if (sortVal === 'discount-asc') {
                filtered.sort((a, b) => a.discount - b.discount);
            } else {
                filtered.sort((a, b) => a.name.localeCompare(b.name));
            }

            countEl.textContent = `${filtered.length}`;
            catalogGrid.innerHTML = '';

            if (filtered.length === 0) {
                catalogGrid.innerHTML = '<div style="grid-column:1/-1;text-align:center;padding:3rem;color:var(--text-light);">No gift cards found.</div>';
                return;
            }

            filtered.forEach(card => {
                const el = document.createElement('div');
                el.className = 'gc-card';
                el.onclick = () => openDetail(card);
                const fallbackHtml = `<div class="gc-card-logo-fallback"><span class="fallback-icon">🎁</span><span>${escHtml(card.name)}</span></div>`;
                el.innerHTML = `
                    <div class="gc-card-logo-area">${card.logoUrl ? `<img class="gc-card-logo" src="${escHtml(card.logoUrl)}" alt="${escHtml(card.name)}">` : fallbackHtml}</div>
                    <div class="gc-card-info">
                        <div class="gc-card-name">${escHtml(card.name)}</div>
                        <div class="gc-card-discount">${card.discount}% off</div>
                    </div>
                `;
                // Swap broken or generic favicons to fallback
                const img = el.querySelector('.gc-card-logo');
                if (img) {
                    const swapToFallback = () => { img.parentElement.innerHTML = fallbackHtml; };
                    img.onerror = swapToFallback;
                    img.onload = () => { if (img.naturalWidth < 32) swapToFallback(); };
                }
                catalogGrid.appendChild(el);
            });
        }

        searchInput.addEventListener('input', renderCards);

        // Sort dropdown
        const sortSelect = document.getElementById('gcSortSelect');
        sortSelect.addEventListener('change', renderCards);

        // ── View Toggle (Grid / Map) ──
        const gridViewEl = document.getElementById('gcGridView');
        const mapViewEl = document.getElementById('gcMapView');
        const gridBtn = document.getElementById('gcViewGrid');
        const mapBtn = document.getElementById('gcViewMap');

        gridBtn.addEventListener('click', () => {
            gridViewEl.style.display = '';
            mapViewEl.style.display = 'none';
            gridBtn.classList.add('active');
            mapBtn.classList.remove('active');
        });
        mapBtn.addEventListener('click', () => {
            gridViewEl.style.display = 'none';
            mapViewEl.style.display = '';
            gridBtn.classList.remove('active');
            mapBtn.classList.add('active');
        });

        // ── Map View Logic ──
        let leafletMap = null;
        let mapMarkers = [];
        const mapContainer = document.getElementById('gcMapContainer');
        const mapLocationInput = document.getElementById('gcMapLocationInput');
        const mapSearchBtn = document.getElementById('gcMapSearchBtn');
        const mapGeolocateBtn = document.getElementById('gcMapGeolocateBtn');
        const mapResultsEl = document.getElementById('gcMapResults');
        const mapResultsList = document.getElementById('gcMapResultsList');

        function initMap(lat, lng) {
            // Clear placeholder
            const placeholder = mapContainer.querySelector('.gc-map-placeholder');
            if (placeholder) placeholder.remove();

            if (leafletMap) {
                leafletMap.setView([lat, lng], 13);
            } else {
                leafletMap = L.map(mapContainer, {
                    center: [lat, lng],
                    zoom: 13,
                    zoomControl: true,
                });
                L.tileLayer('https://{s}.basemaps.cartocdn.com/dark_all/{z}/{x}/{y}{r}.png', {
                    attribution: '',
                    maxZoom: 19,
                }).addTo(leafletMap);
            }

            // Clear old markers
            mapMarkers.forEach(m => leafletMap.removeLayer(m));
            mapMarkers = [];

            // Add user location marker
            const userIcon = L.divIcon({
                html: '<div style="width:14px;height:14px;background:#C9A96E;border:3px solid #fff;border-radius:50%;box-shadow:0 2px 8px rgba(0,0,0,0.4);"></div>',
                iconSize: [14, 14],
                className: '',
            });
            const userMarker = L.marker([lat, lng], { icon: userIcon }).addTo(leafletMap);
            userMarker.bindPopup('<b>Your Location</b>');
            mapMarkers.push(userMarker);

            return leafletMap;
        }

        async function fetchNearby(lat, lng) {
            const res = await fetch(`/api/giftcards/nearby?lat=${lat}&lng=${lng}&radius=10000`);
            const data = await res.json();
            if (!res.ok) throw new Error(data.error || 'Server error');
            return data;
        }

        async function searchNearby(lat, lng) {
            mapSearchBtn.disabled = true;
            mapSearchBtn.textContent = 'Searching...';
            mapResultsList.innerHTML = '<div class="gc-state-msg" style="padding:1.5rem;"><div class="gc-spinner"></div><p>Finding nearby deals...</p></div>';
            mapResultsEl.style.display = '';

            initMap(lat, lng);

            try {
                let data;
                const delays = [0, 1000, 2500];
                for (let attempt = 0; attempt < delays.length; attempt++) {
                    try {
                        if (attempt > 0) {
                            console.warn(`Nearby search attempt ${attempt + 1}...`);
                            mapResultsList.innerHTML = '<div class="gc-state-msg" style="padding:1.5rem;"><div class="gc-spinner"></div><p>Still searching... retrying</p></div>';
                            await new Promise(r => setTimeout(r, delays[attempt]));
                        }
                        data = await fetchNearby(lat, lng);
                        break;
                    } catch (err) {
                        if (attempt === delays.length - 1) throw err;
                    }
                }

                const results = data.results || [];

                // Category → emoji fallback map
                const catEmoji = {
                    'Dining': '🍽️',
                    'Fast Food & Casual': '🍔',
                    'Coffee & Treats': '☕',
                    'Entertainment': '🎬',
                    'Shopping & Fashion': '🛍️',
                    'Home & Grocery': '🏠',
                    'Wellness & Beauty': '💆',
                    'Featured': '⭐',
                    'Other': '🏷️',
                };

                function makeIcon(r) {
                    const emoji = catEmoji[r.category] || '🏷️';
                    if (r.logoUrl) {
                        return L.divIcon({
                            html: `<div style="width:36px;height:36px;border-radius:50%;border:2px solid #fff;box-shadow:0 2px 8px rgba(0,0,0,0.4);overflow:hidden;background:#1E1B18;display:flex;align-items:center;justify-content:center;"><img src="${escHtml(r.logoUrl)}" style="width:100%;height:100%;object-fit:cover;border-radius:50%;" onerror="this.parentElement.innerHTML='<span style=font-size:18px>${emoji}</span>'"></div>`,
                            iconSize: [36, 36],
                            iconAnchor: [18, 18],
                            className: '',
                        });
                    }
                    return L.divIcon({
                        html: `<div style="width:36px;height:36px;background:#2A2520;border:2px solid #fff;border-radius:50%;display:flex;align-items:center;justify-content:center;box-shadow:0 2px 8px rgba(0,0,0,0.4);font-size:18px;">${emoji}</div>`,
                        iconSize: [36, 36],
                        iconAnchor: [18, 18],
                        className: '',
                    });
                }

                results.forEach(r => {
                    const marker = L.marker([r.lat, r.lng], { icon: makeIcon(r) }).addTo(leafletMap);
                    const popupId = `popup-${r.brandId}-${Math.random().toString(36).slice(2, 8)}`;
                    marker.bindPopup(`
                        <div style="min-width:180px;">
                            <div style="font-weight:700;font-size:0.95rem;margin-bottom:4px;">${escHtml(r.locationName)}</div>
                            ${r.address ? `<div style="font-size:0.78rem;opacity:0.7;margin-bottom:6px;">${escHtml(r.address)}</div>` : ''}
                            <div style="display:flex;align-items:center;justify-content:space-between;gap:8px;margin-bottom:10px;">
                                <span style="color:#10b981;font-weight:700;">${r.discount}% off</span>
                                <span style="font-size:0.75rem;opacity:0.6;">${r.distanceMi} mi</span>
                            </div>
                            <button id="${popupId}" style="width:100%;padding:8px 0;border:none;border-radius:8px;background:#C9A96E;color:#1A1714;font-family:'Inter',sans-serif;font-size:0.82rem;font-weight:700;cursor:pointer;">Buy Gift Card</button>
                        </div>
                    `);
                    marker.on('popupopen', () => {
                        const btn = document.getElementById(popupId);
                        if (btn) btn.addEventListener('click', () => {
                            const card = allGiftCards.find(c => c.id === r.brandId);
                            if (card) openDetail(card);
                        });
                    });
                    mapMarkers.push(marker);
                });

                // Fit bounds to show all markers
                if (results.length > 0) {
                    const bounds = L.latLngBounds(mapMarkers.map(m => m.getLatLng()));
                    leafletMap.fitBounds(bounds, { padding: [40, 40], maxZoom: 14 });
                }

                // Render results list
                if (results.length === 0) {
                    mapResultsList.innerHTML = '<div style="text-align:center;padding:2rem;color:var(--text-light);">No matching restaurants found nearby. Try a larger area or different location.</div>';
                } else {
                    mapResultsList.innerHTML = '';
                    results.forEach(r => {
                        const item = document.createElement('div');
                        item.className = 'gc-map-result-item';
                        item.onclick = () => {
                            leafletMap.setView([r.lat, r.lng], 16);
                            mapMarkers.find(m => {
                                const ll = m.getLatLng();
                                return Math.abs(ll.lat - r.lat) < 0.0001 && Math.abs(ll.lng - r.lng) < 0.0001;
                            })?.openPopup();
                        };
                        item.innerHTML = `
                            ${r.logoUrl ? `<img class="gc-map-result-logo" src="${escHtml(r.logoUrl)}" alt="" onerror="this.style.display='none'">` : ''}
                            <div class="gc-map-result-info">
                                <div class="gc-map-result-name">${escHtml(r.locationName)}</div>
                                ${r.address ? `<div class="gc-map-result-address">${escHtml(r.address)}</div>` : ''}
                                <div class="gc-map-result-distance">${r.distanceMi} mi away</div>
                            </div>
                            <div class="gc-map-result-deal">
                                <div class="gc-map-result-discount">${r.discount}% off</div>
                                <div class="gc-map-result-action">View Deal →</div>
                            </div>
                        `;
                        // Click "View Deal" opens the gift card detail modal
                        const dealBtn = item.querySelector('.gc-map-result-deal');
                        dealBtn.addEventListener('click', (e) => {
                            e.stopPropagation();
                            const card = allGiftCards.find(c => c.id === r.brandId);
                            if (card) openDetail(card);
                        });
                        mapResultsList.appendChild(item);
                    });
                }
            } catch (err) {
                console.error('Nearby search failed:', err);
                mapResultsList.innerHTML = '<div style="text-align:center;padding:2rem;color:#dc3545;">Failed to search nearby. Please try again.</div>';
            } finally {
                mapSearchBtn.disabled = false;
                mapSearchBtn.textContent = 'Search';
            }
        }

        // Geocode location text via Nominatim (free)
        async function geocodeLocation(query) {
            const res = await fetch(`/api/geocode?q=${encodeURIComponent(query)}&limit=1`);
            const data = await res.json();
            if (data.length === 0) throw new Error('Location not found');
            return { lat: parseFloat(data[0].lat), lng: parseFloat(data[0].lon), display: data[0].display_name };
        }

        // Search button click
        mapSearchBtn.addEventListener('click', async () => {
            const q = mapLocationInput.value.trim();
            if (!q) return;
            try {
                mapSearchBtn.disabled = true;
                mapSearchBtn.textContent = 'Locating...';
                const loc = await geocodeLocation(q);
                await searchNearby(loc.lat, loc.lng);
            } catch (err) {
                alert('Could not find that location. Try a zip code, city, or full address.');
                mapSearchBtn.disabled = false;
                mapSearchBtn.textContent = 'Search';
            }
        });

        // ── Autocomplete ──
        const autocompleteEl = document.getElementById('gcMapAutocomplete');
        let acTimer = null;
        let acResults = [];
        let acIndex = -1;

        function showAutocomplete(results) {
            acResults = results;
            acIndex = -1;
            if (results.length === 0) { autocompleteEl.style.display = 'none'; return; }
            autocompleteEl.innerHTML = '';
            results.forEach((r, i) => {
                const item = document.createElement('div');
                item.className = 'gc-map-autocomplete-item';
                const parts = r.display_name.split(', ');
                const main = parts.slice(0, 2).join(', ');
                const sub = parts.slice(2, 4).join(', ');
                item.innerHTML = `${escHtml(main)}${sub ? `<small>${escHtml(sub)}</small>` : ''}`;
                item.addEventListener('mousedown', (e) => {
                    e.preventDefault();
                    selectAutocomplete(i);
                });
                autocompleteEl.appendChild(item);
            });
            autocompleteEl.style.display = 'block';
        }

        function selectAutocomplete(i) {
            const r = acResults[i];
            if (!r) return;
            clearTimeout(acTimer);
            acResults = [];
            const parts = r.display_name.split(', ');
            mapLocationInput.value = parts.slice(0, 3).join(', ');
            autocompleteEl.style.display = 'none';
            const lat = parseFloat(r.lat);
            const lon = parseFloat(r.lon);
            // Small delay to let blur/mousedown events settle
            setTimeout(() => searchNearby(lat, lon), 50);
        }

        function updateAcHighlight() {
            autocompleteEl.querySelectorAll('.gc-map-autocomplete-item').forEach((el, i) => {
                el.classList.toggle('active', i === acIndex);
            });
        }

        mapLocationInput.addEventListener('input', () => {
            clearTimeout(acTimer);
            const q = mapLocationInput.value.trim();
            if (q.length < 2) { autocompleteEl.style.display = 'none'; return; }
            acTimer = setTimeout(async () => {
                try {
                    const res = await fetch(`/api/geocode?q=${encodeURIComponent(q)}&limit=5`);
                    const data = await res.json();
                    showAutocomplete(data);
                } catch (err) { autocompleteEl.style.display = 'none'; }
            }, 300);
        });

        mapLocationInput.addEventListener('focus', () => {
            if (acResults.length > 0 && mapLocationInput.value.trim().length >= 2) {
                autocompleteEl.style.display = 'block';
            }
        });

        mapLocationInput.addEventListener('blur', () => {
            setTimeout(() => { autocompleteEl.style.display = 'none'; }, 200);
        });

        // Keyboard navigation
        mapLocationInput.addEventListener('keydown', (e) => {
            if (autocompleteEl.style.display === 'none' || acResults.length === 0) {
                if (e.key === 'Enter') mapSearchBtn.click();
                return;
            }
            if (e.key === 'ArrowDown') {
                e.preventDefault();
                acIndex = Math.min(acIndex + 1, acResults.length - 1);
                updateAcHighlight();
            } else if (e.key === 'ArrowUp') {
                e.preventDefault();
                acIndex = Math.max(acIndex - 1, 0);
                updateAcHighlight();
            } else if (e.key === 'Enter') {
                e.preventDefault();
                if (acIndex >= 0) selectAutocomplete(acIndex);
                else mapSearchBtn.click();
                autocompleteEl.style.display = 'none';
            } else if (e.key === 'Escape') {
                autocompleteEl.style.display = 'none';
            }
        });

        // Geolocate button
        mapGeolocateBtn.addEventListener('click', () => {
            if (!navigator.geolocation) {
                alert('Geolocation is not supported by your browser.');
                return;
            }
            mapGeolocateBtn.textContent = 'Locating...';
            navigator.geolocation.getCurrentPosition(
                async (pos) => {
                    mapGeolocateBtn.innerHTML = '<svg width="18" height="18" viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="2" stroke-linecap="round" stroke-linejoin="round"><circle cx="12" cy="12" r="4"/><path d="M12 2v4"/><path d="M12 18v4"/><path d="M2 12h4"/><path d="M18 12h4"/></svg> Use My Location';
                    await searchNearby(pos.coords.latitude, pos.coords.longitude);
                },
                () => {
                    alert('Could not get your location. Please allow location access or enter an address.');
                    mapGeolocateBtn.innerHTML = '<svg width="18" height="18" viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="2" stroke-linecap="round" stroke-linejoin="round"><circle cx="12" cy="12" r="4"/><path d="M12 2v4"/><path d="M12 18v4"/><path d="M2 12h4"/><path d="M18 12h4"/></svg> Use My Location';
                },
                { enableHighAccuracy: true, timeout: 10000 }
            );
        });

        // ── Detail Modal ──
        const detailModal = document.getElementById('gcDetailModal');
        const detailLoading = document.getElementById('gcDetailLoading');
        const detailContent = document.getElementById('gcDetailContent');
        const denomGrid = document.getElementById('gcDenomGrid');
        const detailSummary = document.getElementById('gcDetailSummary');
        const buyBtn = document.getElementById('gcBuyBtn');

        detailModal.querySelector('.modal-overlay').addEventListener('click', () => {
            detailModal.style.display = 'none';
            document.body.style.overflow = 'auto';
        });

        detailModal.querySelector('.gc-modal-close').addEventListener('click', () => {
            detailModal.style.display = 'none';
            document.body.style.overflow = 'auto';
        });

        async function openDetail(card) {
            currentProductId = card.id;
            selectedDenom = null;

            document.getElementById('gcDetailName').textContent = card.name;
            document.getElementById('gcDetailCategory').textContent = card.category || '';

            detailLoading.style.display = 'block';
            detailContent.style.display = 'none';
            detailSummary.style.display = 'none';
            buyBtn.disabled = true;
            buyBtn.textContent = 'Select a denomination';

            detailModal.style.display = 'flex';
            document.body.style.overflow = 'hidden';

            try {
                const res = await fetch(`/api/giftcards/${card.id}`);
                const data = await res.json();
                if (!res.ok) throw new Error(data.error);

                denomGrid.innerHTML = '';
                if (!data.denominations || data.denominations.length === 0) {
                    denomGrid.innerHTML = '<div style="grid-column:1/-1;text-align:center;padding:1.5rem;color:var(--text-light);font-size:0.9rem;">No denominations in stock right now.</div>';
                } else {
                    data.denominations.forEach(d => {
                        const btn = document.createElement('div');
                        btn.className = 'gc-denom-btn';
                        btn.innerHTML = `
                            <div class="gc-denom-face">$${d.faceValue}</div>
                            <div class="gc-denom-price">$${d.yourPrice.toFixed(2)}</div>
                            <div class="gc-denom-stock">${d.stock} avail</div>
                        `;
                        btn.addEventListener('click', () => {
                            denomGrid.querySelectorAll('.gc-denom-btn').forEach(b => b.classList.remove('selected'));
                            btn.classList.add('selected');
                            selectedDenom = d;

                            document.getElementById('gcSumFace').textContent = `$${d.faceValue}`;
                            document.getElementById('gcSumSave').textContent = `$${d.savings.toFixed(2)} (${card.discount}% off)`;
                            document.getElementById('gcSumPrice').textContent = `$${d.yourPrice.toFixed(2)}`;
                            detailSummary.style.display = 'block';

                            buyBtn.disabled = false;
                            buyBtn.textContent = `Buy for $${d.yourPrice.toFixed(2)}`;
                        });
                        denomGrid.appendChild(btn);
                    });
                }

                detailLoading.style.display = 'none';
                detailContent.style.display = 'block';
            } catch (err) {
                console.error('Failed to load product detail:', err);
                detailLoading.innerHTML = '<p style="color:#dc3545;font-size:0.9rem;">Failed to load details. Try again.</p>';
            }
        }

        // ── Promo Code ──
        let appliedPromo = null;

        document.getElementById('gcPromoApplyBtn').addEventListener('click', async () => {
            const input = document.getElementById('gcPromoInput');
            const resultEl = document.getElementById('gcPromoResult');
            const code = input.value.trim();
            if (!code) return;

            try {
                const res = await fetch('/api/promo/validate', {
                    method: 'POST',
                    headers: { 'Content-Type': 'application/json' },
                    body: JSON.stringify({ code, orderType: 'giftcards', orderAmount: selectedDenom ? selectedDenom.yourPrice : 0 }),
                });
                const data = await res.json();
                if (data.valid) {
                    appliedPromo = { code: data.promo.code, discountType: data.promo.discountType, discountValue: data.promo.discountValue };
                    const label = data.promo.discountType === 'percent' ? data.promo.discountValue + '% off' : '$' + data.promo.discountValue.toFixed(2) + ' off';
                    resultEl.style.display = 'block';
                    resultEl.style.background = 'rgba(46,204,113,0.12)';
                    resultEl.style.color = '#2ecc71';
                    resultEl.innerHTML = '✓ <strong>' + data.promo.code + '</strong> applied — ' + label;
                } else {
                    appliedPromo = null;
                    resultEl.style.display = 'block';
                    resultEl.style.background = 'rgba(220,53,69,0.12)';
                    resultEl.style.color = '#dc3545';
                    resultEl.textContent = data.error || 'Invalid promo code';
                }
            } catch (err) {
                console.error(err);
                resultEl.style.display = 'block';
                resultEl.style.background = 'rgba(220,53,69,0.12)';
                resultEl.style.color = '#dc3545';
                resultEl.textContent = 'Failed to validate promo code';
            }
        });

        // ── Buy Button → Stripe Checkout ──
        buyBtn.addEventListener('click', async () => {
            if (!selectedDenom || !currentProductId) return;

            if (!isLoggedIn()) {
                login();
                return;
            }

            const user = getUser();
            const username = user?.global_name || user?.username || 'Unknown';
            const discordId = user?.id || '';
            const avatarUrl = user?.avatar
                ? `https://cdn.discordapp.com/avatars/${user.id}/${user.avatar}.png?size=128`
                : '';

            const productName = document.getElementById('gcDetailName').textContent;

            buyBtn.disabled = true;
            buyBtn.textContent = 'Redirecting to payment...';

            try {
                const res = await fetch('/api/checkout/giftcard', {
                    method: 'POST',
                    headers: { 'Content-Type': 'application/json', ...authHeaders() },
                    body: JSON.stringify({
                        amount: selectedDenom.faceValue,
                        restaurant: productName,
                        discount: String(selectedDenom.discountPercent),
                        yourPrice: selectedDenom.yourPrice,
                        productId: currentProductId,
                        username,
                        discordId,
                        avatarUrl,
                        promoCode: appliedPromo ? appliedPromo.code : '',
                    }),
                });
                const data = await res.json();
                if (data.url) {
                    window.location.href = data.url;
                } else {
                    alert(data.error || 'Something went wrong');
                    buyBtn.disabled = false;
                    buyBtn.textContent = `Buy for $${selectedDenom.yourPrice.toFixed(2)}`;
                }
            } catch (err) {
                console.error(err);
                alert('Failed to start checkout. Please try again.');
                buyBtn.disabled = false;
                buyBtn.textContent = `Buy for $${selectedDenom.yourPrice.toFixed(2)}`;
            }
        });

        // ── Handle return from Stripe checkout ──
        const urlParams = new URLSearchParams(window.location.search);
        const status = urlParams.get('status');
        const type = urlParams.get('type');
        const sessionId = urlParams.get('session_id');

        if (status === 'success' && type === 'giftcard' && sessionId) {
            (async () => {
                try {
                    const res = await fetch('/api/order/giftcard/complete', {
                        method: 'POST',
                        headers: { 'Content-Type': 'application/json', ...authHeaders() },
                        body: JSON.stringify({ session_id: sessionId }),
                    });
                    const data = await res.json();
                    if (data.success) {
                        document.getElementById('paymentSuccessModal').style.display = 'flex';
                        document.body.style.overflow = 'hidden';
                    } else {
                        alert(data.error || 'Payment verified but order submission failed. Please contact support.');
                        window.history.replaceState({}, document.title, '/offerings');
                    }
                } catch (err) {
                    console.error(err);
                    alert('Payment was successful but we had trouble confirming your order. Please contact support.');
                    window.history.replaceState({}, document.title, '/offerings');
                }
            })();
        } else if (status === 'cancelled') {
            document.getElementById('paymentCancelledModal').style.display = 'flex';
            document.body.style.overflow = 'hidden';
        }

        // ── Tab switching: load catalog when gift cards tab is shown ──
        let catalogLoaded = false;
        document.querySelectorAll('.tab-btn').forEach(btn => {
            btn.addEventListener('click', () => {
                if (btn.dataset.tab === 'giftcards' && !catalogLoaded) {
                    catalogLoaded = true;
                    loadCatalog();
                }
            });
        });

        // Handle hash navigation on page load
        const hash = window.location.hash.replace('#', '');
        if (hash && ['mealkits', 'delivery', 'giftcards'].includes(hash)) {
            // Prevent default anchor scroll by immediately scrolling to top
            window.scrollTo(0, 0);
            
            const targetBtn = document.querySelector(`.tab-btn[data-tab="${hash}"]`);
            if (targetBtn) {
                targetBtn.click();
                // Load gift cards catalog if needed
                if (hash === 'giftcards' && !catalogLoaded) {
                    catalogLoaded = true;
                    loadCatalog();
                }
            }
        }
        
        // If arriving from Stripe redirect
        if (urlParams.get('tab') === 'giftcards' || type === 'giftcard') {
            const gcTabBtn = document.querySelector('.tab-btn[data-tab="giftcards"]');
            if (gcTabBtn) gcTabBtn.click();
        }

        function escHtml(s) { const d = document.createElement('div'); d.textContent = s; return d.innerHTML; }
    